import _get from 'lodash/get'
import { GET_PLAN_ELIGIBILITY } from './query'
import {
  client as apolloClient,
  APOLLO_CLIENT_ERROR_POLICY_ALL,
  APOLLO_CLIENT_FETCH_POLICY_NETWORK_ONLY,
} from '../apollo-graphql/index'

/**
 * Loads plan eligibility via GraphQL (no React hook). Used by checkout watchers.
 * @param {{ sku: string, page: string, jwt?: string|null }} params
 * @returns {Promise<object|null>} billingProviderProductEligibility fields or null on failure
 */
export default async function fetchPlanEligibility ({ sku, page, jwt }) {
  if (!sku || !page) {
    return null
  }
  try {
    const { data } = await apolloClient.query({
      query: GET_PLAN_ELIGIBILITY,
      variables: { sku, page },
      fetchPolicy: APOLLO_CLIENT_FETCH_POLICY_NETWORK_ONLY,
      errorPolicy: APOLLO_CLIENT_ERROR_POLICY_ALL,
      context: {
        jwt,
      },
    })
    return _get(data, 'billingProviderProductEligibility') || null
  } catch (e) {
    return null
  }
}
